import { useEffect } from 'react';
import { cn } from '../../lib/cn.js';
import { useDispatchBoard } from '../../lib/dispatch-board.js';
import { activeSalesTypes, useSalesTypes } from '../../lib/trade.js';

/**
 * Trade-filter chip bar — mockup's `.ib-toolbar`. Updates the dispatch store's
 * filter; the queue rail and board are both driven by that store.
 */
export function FilterBar() {
  const filter = useDispatchBoard((s) => s.filter);
  const setFilter = useDispatchBoard((s) => s.setFilter);
  const salesTypes = useSalesTypes();
  const filters = [
    { id: 'all', label: 'All types', color: null as string | null },
    ...activeSalesTypes(salesTypes).map((t) => ({ id: t.key, label: t.label, color: t.color })),
  ];
  // A type deactivated while it was the selected filter would hide every
  // job — fall back to 'all'.
  useEffect(() => {
    if (filter !== 'all' && !filters.some((f) => f.id === filter)) setFilter('all');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filter, salesTypes]);
  return (
    <div
      className="flex items-center gap-1.5 flex-wrap px-4 py-2 border-b text-xs"
      style={{ borderColor: 'var(--color-border-tertiary)' }}
    >
      <span className="text-ink-muted mr-1">Filter</span>
      {filters.map((f) => (
        <button
          key={f.id}
          type="button"
          onClick={() => setFilter(f.id)}
          aria-pressed={filter === f.id}
          className={cn(
            'inline-flex items-center gap-1.5 rounded-full border px-3 py-1 transition-colors',
            filter === f.id
              ? 'bg-brand-50 border-brand-200 text-ink-accent font-medium'
              : 'bg-surface border-line-subtle text-ink-muted hover:text-ink',
          )}
        >
          {f.color && (
            <span aria-hidden className="inline-block h-2 w-2 rounded-full" style={{ backgroundColor: f.color }} />
          )}
          {f.label}
        </button>
      ))}
    </div>
  );
}
